import React, { useState } from "react";
import axios from "axios";
import { TextField } from "@material-ui/core";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import DialogModal from "../../../elements/dialogModal/DialogModal";
import DefaultButton from "../../../styles/materialButtonStyle";
import TwoFa from "../../../elements/twoFa/TwoFa";
import { useTranslation } from "react-i18next";

import { StyledBlockAction, StyledInputBlock } from "../../../styles/styledTabsForm";
import { check2FA } from "../../../../utils/check2FA";
import getUserInfo from "../../../../utils/getUserInfo";
import { parseAxiosError } from "../../../../utils/response";
import { STANDARD_ERRORS_WAY } from "../../../../utils/consts";

const FeeEditForm = ({ fee, notification, setNotification, url }) => {
  const { t } = useTranslation("clientsPage");
  const [open, setOpen] = useState(false);
  const [error, setError] = useState({});

  const [submitData, setSubmitData] = useState({
    percent: null,
    constant: null,
    min: null,
    max: null,
    constantInUSDT: null
  });

  const handleSave = async (event) => {
    event.preventDefault();

    let check2Fa = await check2FA(getUserInfo()["userId"], event.target.twofa.value);

    if (check2Fa.error) {
      setNotification({ ...notification, visible: true, type: "error", message: check2Fa.error });
      return;
    }

    axios.put(url + fee.id, submitData, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setOpen(false);
        setNotification({
          ...notification,
          visible: true,
          type: "success",
          message: t("details.fee.edit.form.success")
        });
      }
    }).catch(error => {
      setOpen(false);
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  return (
    <>
      <DialogModal
        open={open}
        setOpen={setOpen}
        title={t("details.fee.edit.form.twoFa")}
        content={<TwoFa
          handleSubmit={handleSave}
          error={error}
        />}
      />
      <StyledInputBlock
        as="form"
        className="fee-edit"
        onSubmit={event => {
          event.preventDefault();

          setSubmitData({
            ...setSubmitData,
            percent: event.target.percent.value,
            constant: event.target.constant.value,
            min: event.target.min.value,
            max: event.target.max.value,
            constantInUSDT: event.target.constantInUSDT.value
          });
          setOpen(true);
        }}
      >
        <div className="fee-edit__items">
          <TextField
            className="grid-form__input"
            label={t("details.fee.edit.form.percent")}
            type="text"
            value={fee.baseFee.percent * 100}
            variant="filled"
            InputProps={{
              readOnly: true
            }}
          />
          <TextField
            className="grid-form__input"
            label={t("details.fee.edit.form.constant")}
            type="text"
            value={fee.baseFee.constant}
            variant="filled"
            InputProps={{
              readOnly: true
            }}
          />
          <TextField
            className="grid-form__input"
            label={t("details.fee.edit.form.constantInUSDT")}
            type="text"
            value={fee.baseFee.constantInUSDT}
            variant="filled"
            InputProps={{
              readOnly: true
            }}
          />
          <TextField
            className="grid-form__input"
            label={t("details.fee.edit.form.minBaseFee")}
            type="text"
            value={fee.baseFee.min}
            variant="filled"
            InputProps={{
              readOnly: true
            }}
          />
          <TextField
            className="grid-form__input"
            label={t("details.fee.edit.form.maxBaseFee")}
            type="text"
            value={fee.baseFee.max}
            variant="filled"
            InputProps={{
              readOnly: true
            }}
          />
        </div>
        <div className="fee-edit__items">
          <TextField
            className="grid-form__input"
            variant="filled"
            label={t("details.fee.edit.form.percent")}
            id="percent"
            type="text"
            name="percent"
            defaultValue={fee.cleanPercent * 100}
          />
          <TextField
            className="grid-form__input"
            variant="filled"
            label={t("details.fee.edit.form.constant")}
            id="constant"
            type="text"
            name="constant"
            defaultValue={fee.cleanConstant}
          />
          <TextField
            className="grid-form__input"
            variant="filled"
            label={t("details.fee.edit.form.constantInUSDT")}
            id="constantInUSDT"
            type="text"
            name="constantInUSDT"
            defaultValue={fee.cleanConstantInUSDT}
          />
          <TextField
            className="grid-form__input"
            variant="filled"
            label={t("details.fee.edit.form.minBaseFee")}
            id="min"
            type="text"
            name="min"
            defaultValue={fee.cleanMin}
          />
          <TextField
            className="grid-form__input"
            variant="filled"
            label={t("details.fee.edit.form.maxBaseFee")}
            id="max"
            type="text"
            name="max"
            defaultValue={fee.cleanMax}
          />
        </div>
        <StyledBlockAction>
          <DefaultButton
            color="success"
            type="submit"
          >
            {t("details.fee.edit.form.save")}
          </DefaultButton>
        </StyledBlockAction>
      </StyledInputBlock>
    </>
  );
};

export default FeeEditForm;